// 登陆的路由校验和登陆后的跳转逻辑
import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/conference', '/consortia', '/article', '/home', '/login', '/article', '/software', '/database', '/people', '/news', '/about', '/about/data', '/auth-redirect', '/people/detail', '/news/detail', '/404', '/conf', '/conf/summer', '/conf/summer2024', '/conf/bigbrain', '/conf/summer2023', '/conf/xishuangbanna'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  document.title = getPageTitle(to.meta.title)
  if (whiteList.indexOf(to.path) !== -1) {
    next()
  } else {
    console.log(to.path)
    next({ path: '/404' })
  }
  NProgress.done()
})

router.afterEach(() => {
  NProgress.done()
})
